// @flow
import {
  createAction,
  createActions,
  handleAction,
  handleActions
} from 'redux-actions'
import type { modelEnum } from './models'
import { model } from './models'

export type CategorySelectionState = {
  model: modelEnum,
  income: number,
  year: number
}

export type CategorySelectionActions = {
  type: 'SELECTOR/MODEL/SET' | 'SELECTOR/INCOME/SET' | 'SELECTOR/YEAR/SET',
  payload: string
}

export const selectorActions = createActions({
  SELECTOR: {
    MODEL: {
      SET: undefined
    },
    INCOME: {
      SET: undefined
    },
    YEAR: {
      SET: undefined
    }
  }
})

export const categorySelection: (
  state: CategorySelectionState,
  action: CategorySelectionActions
) => CategorySelectionState = handleActions(
  {
    'SELECTOR/MODEL/SET': (state, action) => {
      return {
        ...state,
        model: action.payload
      }
    },
    'SELECTOR/INCOME/SET': (state, action) => {
      return {
        ...state,
        income: action.payload
      }
    },
    'SELECTOR/YEAR/SET': (state, action) => {
      return {
        ...state,
        year: action.payload
      }
    }
  },
  {
    model: model.MARRIED_WITH_CHILDREN_AND_DUAL_INCOME,
    income: 150000,
    year: 2017
  }
)

export default categorySelection

export const setBrackets = createAction(
  'BRACKETS/SET',
  (brackets: Array<number>) => brackets
)

export const brackets = handleAction(
  setBrackets,
  (state, { payload }) => payload,
  []
)



// WEBPACK FOOTER //
// ./src/components/selector/reducer.js